import { httpInterceptorProviders } from './interceptor';
import { appInitializerProviders } from './initializers';

// central providers for the application - flatten nested provider arrays so Angular registers them
export const coreProviders = [
  ...appInitializerProviders,
  ...httpInterceptorProviders,
];
